import RestAPI from "../utils/restAPI";
import {  useCachedFetch } from "./useCachedFetch";

// Same fields as `IOrganizationObject` in the monorepo, copy over fields from there as needed
export interface Organization {
	organizationId: string;
	organizationName?: string;
}


/**
 * Hook to fetch and cache organization data
 */
export function useOrganizations() {
	return useCachedFetch<Organization[]>("organizations", () =>
		RestAPI.fetchRebuildAPI("/rest/tools/organizations", "GET", {}, "data", true, false)
	);
}
